<script setup lang="ts">
defineProps<{ title: string }>()
</script>

<template>
  <h3 class="title">{{ title }}</h3>
</template>

<style scoped lang="scss">
.title {
  @include h2-1;
}
</style>
